import { motion } from "framer-motion";
import { useLang } from "@/i18n/LanguageContext";
import { TiltCard } from "@/components/spa/TiltCard";

export const Experience = () => {
  const { t } = useLang();
  return (
    <section id="experience" data-testid="experience-section" className="relative py-24 lg:py-40 bg-[#0c100e]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-2xl"
        >
          <div className="flex items-center gap-4 mb-6">
            <span className="h-px w-12 bg-[#c5a059]" />
            <span className="text-[11px] tracking-[0.4em] uppercase text-[#c5a059]">{t.experience.label}</span>
          </div>
          <h2 className="font-serif-display font-medium text-3xl sm:text-4xl lg:text-5xl leading-[1.1] tracking-tight text-[#f0f4f2]">
            {t.experience.title.pre}<span className="italic text-[#c5a059]">{t.experience.title.it}</span>{t.experience.title.post}
          </h2>
        </motion.div>

        <div className="mt-20 grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10">
          {t.experience.steps.map((s, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
            >
              <TiltCard
                testid={`experience-step-0${i + 1}`}
                max={4}
                lift={4}
                glow="0 20px 55px -18px rgba(197,160,89,0.5)"
                className="group relative bg-[#0c100e] hover:bg-[#101512] p-10 lg:p-12 overflow-hidden h-full"
              >
                <span className="absolute -top-6 -right-3 font-serif-display text-[7rem] leading-none text-white/[0.04] group-hover:text-[#c5a059]/10 transition-colors duration-500 select-none">
                  0{i + 1}
                </span>
                <span className="font-serif-display italic text-lg text-[#c5a059]">0{i + 1}</span>
                <h3 className="mt-6 font-serif-display text-2xl text-[#f0f4f2]">{s.title}</h3>
                <p className="mt-4 text-sm text-[#8a9690] font-light leading-relaxed">{s.text}</p>
                <span className="absolute bottom-0 left-0 h-[2px] w-0 bg-[#c5a059] group-hover:w-full transition-[width] duration-700" />
              </TiltCard>
            </motion.div>
          ))}
        </div>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1.2, delay: 0.3 }}
          className="mt-16 text-sm text-[#8a9690] font-light max-w-xl leading-relaxed"
        >
          {t.experience.note}
        </motion.p>
      </div>
    </section>
  );
};
